'use client'

import { useEffect, useRef, useState } from 'react'

/**
 * Keep the post-paint flip: Web3Provider gates AppKit initialization on this value, and
 * initializing AppKit before EIP-6963 wallets announce can omit MetaMask and Ledger.
 */
export function useIsMounted() {
  const isMountedRef = useRef(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    isMountedRef.current = true
    // oxlint-disable-next-line react/react-compiler -- AppKit must wait for EIP-6963 wallet announcements
    setIsMounted(true)
    return () => {
      isMountedRef.current = false
    }
  }, [])

  return isMounted
}
